import { supabase } from '../context/AuthContext';

export async function apiFetch(url, options = {}) {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  // Demo browser-trial ID — harmless for non-demo users (the backend
  // only reads it when isDemoUser(user.id) is true). Generated and
  // persisted by AuthContext on first demo sign-in.
  if (typeof window !== 'undefined') {
    const trialId = window.localStorage?.getItem('propsight:demo_trial_id');
    if (trialId) headers['x-demo-trial'] = trialId;
  }
  return fetch(url, { ...options, headers });
}

// Public aggregate endpoints (/api/core, /api/areas, /api/projects) need
// a static fallback so the UI still renders under `react-scripts start`,
// where /api/* paths fall through to index.html (the SPA route) instead
// of hitting the Vercel function. In that case fetch() returns 200 with
// text/html, so .json() throws — we catch it and read the pre-rendered
// JSON shipped in public/data/ instead. Same shape on both paths.
const STATIC_FALLBACK = {
  '/api/core':     '/data/core.json',
  '/api/areas':    '/data/areas.json',
  '/api/projects': '/data/projects.json',
};

export async function fetchAggregate(apiPath) {
  try {
    const r = await fetch(apiPath);
    const ct = r.headers.get('content-type') || '';
    if (!r.ok || !ct.includes('application/json')) throw new Error('not_json');
    return await r.json();
  } catch {
    const staticPath = STATIC_FALLBACK[apiPath];
    if (!staticPath) return null;
    try {
      const r = await fetch(staticPath);
      return r.ok ? await r.json() : null;
    } catch {
      return null;
    }
  }
}
